import { Box, useTheme } from "@mui/material";
import type { ReactNode } from "react";
import { PRICING_DESIGN_VALUES } from "./pricingDesignValues";

interface PricingPageFrameProps {
  children: ReactNode;
  /** The cancelled banner sits directly on the panel: no top gap, square top corners. */
  hasBannerAbove: boolean;
}

export const PricingPageFrame = ({
  children,
  hasBannerAbove,
}: PricingPageFrameProps) => {
  const theme = useTheme();
  const { gap, radius } = PRICING_DESIGN_VALUES.pageFrame;

  return (
    <Box
      sx={{
        // PH-10 · not in any CSS spec. KbLayout uses the same frame colour;
        // the design screenshots read slightly darker (≈ neutral["015"]).
        backgroundColor: theme.palette.neutral["010"],
        padding: hasBannerAbove ? `0 ${gap} ${gap}` : gap,
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.palette.neutral.main,
          borderRadius: hasBannerAbove ? `0 0 ${radius} ${radius}` : radius,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
